import { useEffect } from "react";
import { useNatively } from "natively";

/**
 * Initializes the Natively SDK for native app wrapper integration.
 * This component must be rendered once at the app root level.
 * It enables window.natively and related SDK classes like NativelyFirebaseNotifications.
 */
export function NativelyInit() {
  const natively = useNatively();

  useEffect(() => {
    // Enable debug mode if available
    try {
      if (natively?.setDebug) {
        natively.setDebug(true);
      }
    } catch {
      // Could not enable debug mode
    }
  }, [natively]);

  return null;
}
